import * as React from 'react';
import { TViewsState, TViewsProps, TApiResponse } from '../mixin/types';
import { AppCtx } from '../mixin/app_context';
import { getScene, getUrl, pathRedirect, uniqArrayObj } from '../mixin/functions';
import { Card, CardBody, CardText, CardTitle, Col, Input, Row, Button, Icon, Select, LinkList, LinkListItem } from 'deda-rkit';
import ReadMoreFA from '../components/readMoreFA';
import { Link, Navigate } from 'react-router-dom';
import FlashAlert from '../components/flashAlert';
import parse from "html-react-parser";
import DOMPurify from "dompurify";
import GrigliaCards from '../components/grigliaCard';

export default class Index extends React.Component<TViewsProps, TViewsState>{

  context!: React.ContextType<typeof AppCtx>
  static contextType = AppCtx;

  constructor(props) {
    super(props);
    this.state = {
      scene: null,
      flash: null,
      searchQuery: '',
      url_servizio: null,
    };
    this.linkServizio = this.linkServizio.bind(this);
  }

  async componentDidMount() {

    this.props.updateBreadcrumb(null);
    //breadcrumb caso integrato
    if(this.context?.confEnte.external_footer != null && 
      this.context?.confEnte.external_footer != '' &&
      this.context?.confEnte.external_header != null &&
      this.context?.confEnte.external_header != ''
    ){
      this.props.updateBreadcrumb({label: 'area personale',url: '/portal/'});
    }

    const current_url = window.location.toString();
    console.log("ESEGUO componentDidMount su index e schede_informative");
   
    const promise1 = getScene(this.props.apiClient, current_url, this.props.updateLoader);
    const promise2 = getScene(this.props.apiClient, '/portal/schede_informative', this.props.updateLoader);
    
    /* faccio le chiamate in parallelo */
    Promise.all([promise1, promise2]).then(response => {
        const spiderScene: TApiResponse= response[0];
        const spiderscene2: TApiResponse = response[1];

        if(spiderScene.dati?.url_redirect){
          this.props.updateLoader(true); /* attivo loader */
          /* controllo se ho un redirect da fare su un servizio cas */
          if(spiderScene.dati?.servizio_cas){
            console.log("FACCIO REDIRECT PER SERVIZIO CAS");
            window.location.href = spiderScene.dati.url_redirect;
          }else{
            /* setto url_servizio per effettuare redirect con navigate */
            this.setState({url_servizio: "/portal/"+pathRedirect(spiderScene.dati.url_redirect), flash: spiderScene.flash});
          }
          
        }else{ /* set scene generale */
          //this.setState({scene: responseApi.dati, flash: responseApi.flash});
          console.log(spiderScene);
          let newSceneObj: any = { scene: spiderScene.dati, flash: spiderScene.flash }
          if(spiderscene2.dati?.url_redirect){
            this.props.updateLoader(true); /* attivo loader */
            /* setto url_servizio per effettuare redirect con navigate */
            this.setState({url_servizio: "/portal/"+pathRedirect(spiderscene2.dati.url_redirect), flash: spiderscene2.flash});
          }else{ /* set scene generale facendo il merge delle due response*/
            console.log(spiderscene2);
            newSceneObj = {flash: {...newSceneObj.flash, ...spiderscene2.flash}, scene: {...newSceneObj.scene,...spiderscene2.dati}};
            this.setState(newSceneObj);
          }
        }
    }).catch(err => {
        // Do something with the error
        this.setState({ flash: {'dangerMsg':err} });
    });


    // const spiderScene: TApiResponse = await getScene(this.props.apiClient, current_url, this.props.updateLoader);
    
    // if(spiderScene.dati?.url_redirect){
    //   this.props.updateLoader(true); /* attivo loader */
    //   /* controllo se ho un redirect da fare su un servizio cas */
    //   if(spiderScene.dati?.servizio_cas){
    //     console.log("FACCIO REDIRECT PER SERVIZIO CAS");
    //     window.location.href = spiderScene.dati.url_redirect;
    //   }else{
    //     /* setto url_servizio per effettuare redirect con navigate */
    //     this.setState({url_servizio: "/portal/"+pathRedirect(spiderScene.dati.url_redirect), flash: spiderScene.flash});
    //   }
      
    // }else{ /* set scene generale */
    //   //this.setState({scene: responseApi.dati, flash: responseApi.flash});
    //   console.log(spiderScene);
    //   let newSceneObj: any = { scene: spiderScene.dati, flash: spiderScene.flash }
    //   //ora faccio la seconda chiamata per le schede informative
    //   const spiderscene2: TApiResponse = await getScene(this.props.apiClient, '/portal/schede_informative', this.props.updateLoader);
    //   if(spiderscene2.dati?.url_redirect){
    //     this.props.updateLoader(true); /* attivo loader */
    //     /* setto url_servizio per effettuare redirect con navigate */
    //     this.setState({url_servizio: "/portal/"+pathRedirect(spiderscene2.dati.url_redirect), flash: spiderscene2.flash});
    //   }else{ /* set scene generale facendo il merge delle due response*/
    //     console.log(spiderscene2);
    //     newSceneObj = {flash: {...newSceneObj.flash, ...spiderscene2.flash}, scene: {...newSceneObj.scene,...spiderscene2.dati}};
    //     this.setState(newSceneObj);
    //   }
    // }



    //window.scrollTo(0,0);

  }


  /**
   * Filtra l'array per nome del servizio (funzione filtro da passare alla filter() di Array<any>)
   * @returns {object}
   */

  filterByServiceNameAndDescription(service: any): object | void {

    if (this.state.searchQuery === '' || this.state.searchQuery == null) return service;
    else if (service['nome'].toLowerCase().includes(this.state.searchQuery.toLowerCase())) return service;
    else if (service['descrizione'] != null && service['descrizione'].toLowerCase().includes(this.state.searchQuery.toLowerCase())) return service;
  }

  // Non usato, siamo già nella home
  // updateBreadcrumb(breadcrumbNested){
  //   this.setState(prevState => ({breadcrumb: [...prevState['breadcrumb'],breadcrumbNested]}));
  // }

  async linkServizio(event) {

    event.preventDefault();

    /* distinguo il caso in cui il click lo faccio sul link del titolo o sul link "VAI ALLA PAGINA" */
    const id_servizio: string | null = event.target.tagName == 'A' ? (new URL(event.target.href)).searchParams.get('serv_id') : (new URL(event.target.parentElement.href)).searchParams.get('serv_id');
    
    const url_api = `/portal/get_url_servizio?id_servizio=${id_servizio}`;
    
    const linkServizio: TApiResponse = await getUrl(this.props.apiClient, url_api);
    
    if (linkServizio != null && linkServizio.esito === 'ok') {
      
      if (linkServizio.dati.redirect_url != null) {
        
        if (linkServizio.dati.redirect_url.startsWith('http')) {
          
          console.log("Redirect su " + linkServizio.dati.redirect_url);
          window.location.href = linkServizio.dati.redirect_url;
          
        } else {

          console.log("Redirect react su " + linkServizio.dati.redirect_url);
          //return(<Redirect to={linkServizio.dati.redirect_url}/>)
          this.setState({ url_servizio: linkServizio.dati.redirect_url})
        }

      } else {

        throw new Error("Redirect url non configurato per servizio " + id_servizio);
      }

    } else {
      throw new Error("Network response ko");
    }
  }


  /**
   * Filtra insistendo su nome, descrizione e categoria
   * di schede informative e servizi. 
   * Restituisce eventualmente la card se questa rispetta i requisiti
   * 
   * @argument { infocard } card - la card da esaminare
   * @returns { boolean }
   */
  filterFullText(card: any): boolean {

    const query: string | null | undefined = this.state.searchQuery;

    if (query === '' || query == null) return card;
    else if (card.titolo != null && card.titolo.toLowerCase().includes(query.toLowerCase())
      || card.nome != null && card.nome.toLowerCase().includes(query.toLowerCase())) return card;

    else if (card.descrizione != null && card['descrizione'].toLowerCase().includes(query.toLowerCase())) return card;
    else if (card.categoria.desc.toLowerCase().includes(query.toLowerCase())) return card;

    return false;
  }

  /**
   * Filtra insistendo sulla categoria
   * delle schede informative e restituisce eventualmente la card
   * se questa rispetta i requisiti
   * 
   * @param card - la card da esaminare
   * @returns { boolean }
   */
  filterByCategory(card: any): boolean {

    const category: string | null | undefined = this.state.categoryFilter;

    if (category === '' || category == null) return card;
    else if (typeof card.categoria !== 'undefined' && card.categoria.desc.toLowerCase().includes(category.toLowerCase())) return card;

    return false;
  }


  /**
   * Filtra le stringhe in ordine ascendente (A-Z)
   * 
   * @param {string} a
   * @param {string} b
   * @returns {(-1 | 0 | 1)} -1 se a < b oppure 0 se a = b oppure 1 se a > b
   */
  filterAscendantString(a: string, b: string): (-1 | 0 | 1){

    switch (true) {

      case a > b:
        return 1;

      case a === b:
        return 0;

      case a < b:
        return -1;

      default:
        return 0;

    }

  }

  appendIdServizio(url:string,id:string) {
    if(url.includes('?')){
      return url+"&serv_id="+id
    }else{
      /* se ho uno / alla fine lo tolgo */
      //return url.replace(/\/(?=[^\/]*$)/, '')+"?"+id
      return url+"?serv_id="+id
    }
    
  }


  render() {
    if(this.state.url_servizio != null){ return ( <Navigate to={this.state.url_servizio} />)}
    //la lista dei servizi cambia se utente loggato
    let arrayServizi = []
    if(this.state.scene != null){
      arrayServizi =  (this.context?.confEnte.utente_loggato ? this.state.scene.servizi_privati_utente : this.state.scene.tutti_servizi_utente)
    }
   
    // Creazione array che contiene le categorie delle schede informative
    let cats_array: any[] = [];

    if (this.state.scene != null && arrayServizi != null) {
      cats_array.push({ value: 'servizi', label: 'Servizi' })
    }

    if (this.state.scene?.schede_informative) {

      this.state.scene.schede_informative.forEach(element => {
        
        if (element.categoria != null) cats_array.push({ value: element.categoria.id, label: element.categoria.desc });
      })

      // Chiamo funzione per avere voci univoche ed invoco la sort sul suo output per ordinarlo per nome della label
      cats_array = uniqArrayObj(cats_array).sort((a, b) => this.filterAscendantString(a.label, b.label));

    }

    return (

      <div>
        <FlashAlert flash={this.state.flash != null ? this.state.flash : null} />
        <section className="areapersonale-sezione">
          {this.state.scene && this.state.scene.login_effettuato != true ? (  //controllo login e caricamento dei dati idonei
            <>
              {this.context?.confEnte.testo_introduttivo_principale != null && (
                <Row>
                  <Col md="6" sm="12">
                    <Card spacing={true} className='bg_testo_introduttivo'>
                      <CardBody>
                        <CardTitle tag='h1' className='h4'>
                          {this.context?.confEnte.testo_introduttivo_principale}
                        </CardTitle>
                        <CardText>
                          {this.context?.confEnte.testo_introduttivo_secondario}
                        </CardText>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg="6" md="6" className='d-none d-md-block'>
                    <img src="/portal/public/img/istanze.webp" width="100%" height="auto" aria-label='Immagine Istanze Servizi' title="Immagine Istanze Servizi" alt="Immagine Istanze Servizi" className='img-fluid' />
                  </Col>
                </Row>)
              }
              <Row>
                <Col lg='5' className='input_search'>
                  <Input type='search' placeholder='Cerca' onChange={(e) => { this.setState({ searchQuery: e.target.value }) }} />
                </Col>
                <Col className='mb-4 mb-md-0'>
                  <Select options={cats_array}
                    onChange={(value) => (value !== null) ? this.setState({ categoryFilter: value['label'] }) : this.setState({ categoryFilter: '' })}
                    placeholder='Filtra per categoria'
                    isClearable
                    aria-label="Filtra per categoria"
                  />
                </Col>
                <Col xs={12} md={4} className='order-first order-md-last mb-xs-3 mt-3'>
                  <LinkList>
                    <LinkListItem tag={'h2'} className='h3'>
                      Vai alla sezione
                    </LinkListItem>
                    <LinkListItem divider />

                    {this.state.scene?.schede_informative && this.state.scene.schede_informative.length > 0  && (
                      <LinkListItem href='#infocard-section'>
                        <span>Schede informative</span>
                      </LinkListItem>
                    )}

                    {arrayServizi != null && arrayServizi.length > 0 && (
                    <LinkListItem href='#serv-section'>
                      <span>Servizi</span>
                    </LinkListItem>)}
                  </LinkList>
                </Col>
              </Row>
              
              {this.state.scene?.schede_informative && this.state.scene?.schede_informative.length > 0 && (
                <>
                <div id='infocard-section' className='anchor' />
                <Row className='my-5'>
                  <Col className='border-bottom'>
                    <h1 className="title-xxxlarge deda-h1">Schede informative</h1>
                  </Col>
                </Row>
              
                <GrigliaCards arrayCard={
                  this.state.scene.schede_informative.filter((element) => {

                    /**
                     * Se la categoria dell'elemento è corretta allora filtra pure in base al nome e
                     * alla descrizione, altrimenti non restituire l'elemento nella view
                     */
                    return this.filterByCategory(element) ? this.filterFullText(element) : false;

                  }).map((element, index) => (
                      <Card key={'scheda' + element.id} spacing={true} className='card-bg' wrapperClassName="deda_card_margin">
                        <div className='etichetta pt-4 ps-4'>
                          <Icon icon='it-settings' />
                          <span>{element.categoria !== null && (<span>{element.categoria.desc}</span>)}</span>
                        </div>
                        <CardBody className='mt-3'>
                          <Link to={'/portal/schede_informative/'+element.id} data-element="service-link">
                            <CardTitle tag='h2' className='h5'>
                              {element.titolo}
                            </CardTitle>
                          </Link>
                          <CardText>
                            {parse(DOMPurify.sanitize(element.descrizione, {
                            USE_PROFILES: { html: true },}))}
                          </CardText>
                          <ReadMoreFA iconName="it-arrow-right" text='Vai alla pagina' href={'/portal/schede_informative/' + element.id} />
                        </CardBody>
                      </Card>
                  ))}></GrigliaCards>
                </>
              )}

              {arrayServizi != null && arrayServizi.length > 0 && (
                <>
                  <div id='serv-section' className='anchor' />
                  <Row className='my-5'>
                    <Col className='border-bottom'>
                      <h1 className="title-xxxlarge deda-h1">Servizi</h1>
                    </Col>
                  </Row>
                </>
              )}

              {arrayServizi != null &&(
              <GrigliaCards arrayCard={
                arrayServizi.filter((element) => {

                  /**
                   * Se la categoria dell'elemento è corretta allora filtra pure in base al nome e
                   * alla descrizione, altrimenti non restituire l'elemento nella view
                   */
                  return this.filterByCategory(element) ? this.filterFullText(element) : false;

                }).map((element, index) => (
                    <Card key={'scheda' + element.id} spacing={true} className='card-bg' wrapperClassName="deda_card_margin">
                      <div className='etichetta pt-4 ps-4 '>
                        <Icon icon='it-pa' />
                        <span>Servizi</span>
                        {/* {element.categoria !== null && (<span>{element.categoria.desc}</span>)} */}
                      </div>
                      <CardBody className='mt-3'>
                        <a onClick={this.linkServizio} href={this.appendIdServizio(element.url,element.id)}>
                          <CardTitle tag='h2' className='h5'>
                            {element.nome}
                          </CardTitle>
                        </a>
                        <CardText>
                          {parse(DOMPurify.sanitize(element.descrizione, {
                          USE_PROFILES: { html: true },}))}
                        </CardText>
                        <ReadMoreFA iconName="it-arrow-right" clickFunction={this.linkServizio} text='Vai alla pagina' href={this.appendIdServizio(element.url,element.id)} />
                      </CardBody>
                    </Card>
                  
                ))}></GrigliaCards>
              )}
            </>) : (
            <>
              <Row className='py-3'>
                {this.state.scene != null && this.state.scene.utente_portale.nome != null && (
                  <Col className='text-center'>
                    <h1 className="title-xxxlarge deda-h1">Bentornato/a <strong>{this.state.scene.utente_portale.nome}</strong></h1>
                  </Col>)}
              </Row>

              
              {this.state.scene && arrayServizi != null && arrayServizi.length > 0 && (
                <Row className='my-3'>
                  <Col xs='6' md='6' lg='6'>
                    <h1 className="title-xxxlarge deda-h1">I tuoi servizi</h1>
                  </Col>
                  <Col xs='6' md='6' lg='6' className='text-end'>
                    <Link to='/portal/servizi'>
                      <Button className={"btn-outline-primary bg-white " + ((
                          this.context?.confEnte.external_footer != null && 
                          this.context?.confEnte.external_footer != '' &&
                          this.context?.confEnte.external_header != null &&
                          this.context?.confEnte.external_header != ''
                        )? 'visually-hidden' : '')} href='#'>Gestisci i tuoi servizi</Button>
                    </Link>
                  </Col>
                </Row>
              )}

              {this.state.scene && arrayServizi && (
              <GrigliaCards arrayCard={
                arrayServizi.filter((element) => this.filterByServiceNameAndDescription(element)).map((element, index) => (
                    <Card key={'scheda' + element.id} spacing={true} className='card-bg' wrapperClassName="deda_card_margin">
                      <div className='etichetta pt-4 ps-4'>
                        <Icon icon='it-pa' />
                        <span>Servizi</span>
                        {/* {element.categoria !== null && (<span>{element.categoria.desc}</span>)} */}
                      </div>
                      <CardBody className='mt-5'>
                        <a onClick={this.linkServizio} href={this.appendIdServizio(element.url,element.id)}>
                          <CardTitle tag='h2' className='h5'>
                            {element.nome}
                          </CardTitle>
                        </a>
                        <CardText>
                          {parse(DOMPurify.sanitize(element.descrizione, {
                          USE_PROFILES: { html: true },}))}
                        </CardText>
                        <ReadMoreFA iconName="it-arrow-right" clickFunction={this.linkServizio} text='Vai alla pagina' href={this.appendIdServizio(element.url,element.id)} />
                      </CardBody>
                    </Card>
                ))}></GrigliaCards>
            )}

              { this.state.scene && this.context?.confEnte.utente_loggato && (
                <>
                  <Row className='my-3'>
                    {this.state.scene?.servizi_pubblici != null && this.state.scene?.servizi_pubblici.length > 0 &&
                    <Col xs='12' md='12' lg='12'>
                      <h1 className="title-xxxlarge deda-h1">Servizi Pubblici senza autenticazione</h1>
                    </Col>
                    }
                  </Row>

                  {this.state.scene && this.state.scene.servizi_pubblici && (
                  <GrigliaCards arrayCard={
                    this.state.scene && this.state.scene.servizi_pubblici && this.state.scene.servizi_pubblici.map((element, index) => (
                      <Card key={'scheda' + element.id} spacing={true} className='card-bg' wrapperClassName="deda_card_margin">
                        <div className='etichetta pt-4 ps-4'>
                          <Icon icon='it-pa' />
                          <span>Servizi</span>
                          {/* {element.categoria !== null && (<span>{element.categoria.desc}</span>)} */}
                        </div>
                        <CardBody className='mt-5'>
                          <a onClick={this.linkServizio} href={this.appendIdServizio(element.url,element.id)}>
                            <CardTitle tag='h2' className='h5'>
                              {element.nome}
                            </CardTitle>
                          </a>
                          <CardText>
                            {parse(DOMPurify.sanitize(element.descrizione, {
                            USE_PROFILES: { html: true },}))}
                          </CardText>
                          <ReadMoreFA iconName="it-arrow-right" clickFunction={this.linkServizio} text='Vai alla pagina' href={this.appendIdServizio(element.url,element.id)} />
                        </CardBody>
                      </Card>
                  ))}></GrigliaCards>
                  )}
                </>

              )}
              


            </>
          )}
        </section>

      </div>



    );
  }
}
